import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

export const HomeBanner = (props) => {
  const {
    UIComponent
  } = props

  const [homePageBanner, setHomePageBanner] = useState({})

  const handleGetHomeBanner = async () => {
    const res = await fetch('https://plugins-development.ordering.co/ethnicfoodmart/get_homepage_banner.php', {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: JSON.stringify({
        id: ''
      })
    })
    const result = await res.json()
    setHomePageBanner(result.homepagebanner)
  }
  useEffect(() => {
    handleGetHomeBanner()
  }, [])
  return (
    <>
      {UIComponent && (
        <UIComponent
          {...props}
          homePageBanner={homePageBanner}
        />
      )}
    </>
  )
}

HomeBanner.propTypes = {
  /**
   * UI Component, this must be containt all graphic elements and use parent props
   */
  UIComponent: PropTypes.elementType,
  /**
   * Function to edit product behavior
   */
  handleEditProduct: PropTypes.func,
  /**
   * String filter to fetch validation fields
   */
  validationFieldsType: PropTypes.string
}
